// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"49":"ed6ada22","245":"4099bed5","488":"e5b06f00","762":"56a046b1","968":"de473c0e"}[chunkId] + ".chunk.js");